<template>
    <div>
        <div class="fist-page-text"></div>
            <h5 class="line-height-lg mt-10">
                Cosa sono i cookie?
            </h5>

            <p>
                I cookie sono stringhe di testo che i siti web visitati dall’utente (c.d. <strong>“prime parti”</strong>) ovvero siti web o web server
                diversi (c.d. <strong>“terze parti”</strong>) posizionano e archiviano, direttamente (nel caso di siti prime parti) o indirettamente,
                cioè per il tramite di questi ultimi (nel caso delle terze parti) all’interno di un dispositivo terminale nella
                disponibilità dell’utente medesimo.
            </p>

            <p>
                I cookie <strong>possono assolvere a diverse funzioni</strong>, tra cui il monitoraggio di sessioni, la memorizzazione di informazioni su
                specifiche configurazioni riguardanti gli utenti che accedono al server, l’agevolazione nella fruizione di contenuti on
                line, ecc. Sempre attraverso i cookie è anche possibile veicolare informazioni promozionali personalizzate in base agli
                interessi dell’utente o conformare i servizi resi ai comportamenti dell’utente oggetto di una precedente osservazione.
            </p>

            <p>
                A seconda della funzione che assolvono, i cookie si possono classificare essenzialmente in:
            </p>

            <p>
                – <strong>cookie tecnici</strong>, utilizzati al solo fine di consentire il funzionamento del sito;
            </p>
            <p>
                – <strong>cookie di profilazione</strong>, utilizzati al fine di ricondurre a soggetti determinati specifiche azioni o schemi
                comportamentali, in modo da creare dei profili di utenti e inviare messaggi promozionali in linea con le preferenze
                manifestate dall’utente nella navigazione od offrire all’utente contenuti personalizzati.
            </p>
            <p>
                I cookie possono essere utilizzati anche per valutare l’efficacia di un servizio offerto da un sito web o per
                contribuire ad analizzarne il traffico: in tal caso, i cookie utilizzati sono definiti <strong>c.d. cookie analytics.</strong>
            </p>
            <p>
                Sussistendo determinate condizioni, tra le quali, in particolare, l’impossibilità di pervenire mediante il loro utilizzo
                alla diretta individuazione dell’interessato, i cookie analytics sono equiparati ai cookie tecnici sotto il profilo
                delle condizioni e degli adempimenti che ne legittimano l’utilizzo.
            </p>

            <p class="text-center my-5">***&nbsp;&nbsp; ***&nbsp;&nbsp; ***</p>

            <p>
                Questo sito utilizza i seguenti cookie:
            </p>

            <table class="table">
                <thead>
                    <tr>
                        <th>Cookie</th>
                        <th>Funzione</th>
                        <th>Prima parte o terza parte</th>
                        <th>Durata</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>_GRECAPTCHA</td>
                        <td>Google Recaptcha</td>
                        <td>Terza parte</td>
                        <td>Google reCAPTCHA imposta un cookie necessario (_GRECAPTCHA) quando viene eseguito allo scopo di fornire la sua analisi dei rischi</td>
                    </tr>
                </tbody>
            </table>

            <p class="mt-5">
                <strong>Cookie analytics</strong>
            </p>

            <table class="table">
                <thead>
                    <tr>
                        <th>Cookie</th>
                        <th>Funzione</th>
                        <th>Prima parte o terza parte</th>
                        <th>Durata</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>_ga_T7W54X9SPK</td>
                        <td>Google Analytics</td>
                        <td>Terza parte</td>
                        <td>1 anno e 1 mese</td>
                    </tr>
                    <tr>
                        <td>_ga</td>
                        <td>Google Analytics</td>
                        <td>Terza parte</td>
                        <td>1 anno e 1 mese</td>
                    </tr>
                </tbody>
            </table>

            <p class="mt-5">
                <strong>Cookie di profilazione/marketing</strong>
            </p>

            <table class="table">
                <thead>
                    <tr>
                        <th>Cookie</th>
                        <th>Funzione</th>
                        <th>Prima parte o terza parte</th>
                        <th>Durata</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>smuuid</td>
                        <td>Sales Manago</td>
                        <td>Terza parte</td>
                        <td>di sessione</td>
                    </tr>
                    <tr>
                        <td>smvr</td>
                        <td>Sales Manago</td>
                        <td>Terza parte</td>
                        <td>1 anno e 1 mese</td>
                    </tr>
                    <tr>
                        <td>_fbc</td>
                        <td>Meta Ads</td>
                        <td>Terza parte</td>
                        <td>3 mesi</td>
                    </tr>
                    <tr>
                        <td>fr</td>
                        <td>Meta Ads</td>
                        <td>Terza parte</td>
                        <td>3 mesi</td>
                    </tr>
                    <tr>
                        <td>lastExternalReferrer</td>
                        <td>Meta Ads</td>
                        <td>Terza parte</td>
                        <td>durata della sessione</td>
                    </tr>
                    <tr>
                        <td>lastExternalReferrerTime</td>
                        <td>Meta Ads</td>
                        <td>Terza parte</td>
                        <td>durata della sessione</td>
                    </tr>
                    <tr>
                        <td>_fbp</td>
                        <td>Meta Ads</td>
                        <td>Terza parte</td>
                        <td>3 mesi</td>
                    </tr>
                </tbody>
            </table>
            
            <p class="mt-5">Per i <u>cookie tecnici e analytics anonimizzati</u> la base giuridica del trattamento è rappresentata dalla
                necessità di dare esecuzione ad un contratto del quale è parte l’interessato, avente ad oggetto la fruizione del
                sito e dei suoi servizi (art. 6 par. 1 lett. b) GDPR); si precisa, peraltro, che i cookie analytics sono stati
                anonimizzati e, pertanto, non vi è trattamento di dati riconducibili ad un singolo utente. 
            </p>

            <p>Ai sensi dell’art. 13 del Regolamento UE 2016/679 (GDPR) si precisa, altresì, che il Titolare del trattamento dei
                dati con riferimento ai cookie non di terze parti è la società Edizioni Centro Studi Erickson S.p.A., con sede
                legale in Trento, via del Pioppeto n.24, che potrà contattare per qualunque informazione all’indirizzo
                privacy@erickson.it. A ciascun utente competono i diritti di cui all’art. 15 e ss del GDPR, ivi compreso il diritto
                di presentare reclamo all’Autorità Garante per la protezione dei dati personali. Il Titolare del trattamento ha
                nominato un Responsabile della Protezione dei Dati Personali (DPO), che può essere contattato inviando un’e-mail
                all’indirizzo <a href="mailto:dpo@erickson.it" aria-label="Invia email a dpo@erickson.it">dpo@erickson.it</a>.</p>
        </div>
    </div>
</template>
<script>

export default{
    name: "CookiePolicy",
    mounted(){
        this.$parent.hidePageLayout = false
        this.$parent.title = 'Cookie Policy'
    }
}

</script>